import {
  getFromLocalStorage,
  getNewFeatureAccessedFlag,
} from '../utils/localStorageUtils';

export const USER_KEY = 'user';
export const EXTRACT_DATA_KEY = 'EXTRACT_DATA';
export const NOTIFICATION_SHOWN_KEY = 'NOTIFICATION_SHOWN';

export const getCurUser = () => getFromLocalStorage(USER_KEY);

// NEW FEATURE FLAGS
export const getExtractDataIsAccessed = () =>
  getNewFeatureAccessedFlag(EXTRACT_DATA_KEY);
